// when you click the read more pill, the respective details for
// that bullet will expand and the pill symbol will change to a
// negative sign
// make this happen by toggling CSS classes
document.querySelectorAll('.pill--moreinfo').forEach(item => {
  item.onclick = function handleDetails() {
    document
      .querySelector(`#detail-${item.getAttribute('id')}`)
      .classList.toggle('display-none');

    item.classList.toggle('open');
  };
});
